<header [class]="cx('header')">
  <h1 [class]="cx('caption')">
    @if (captionTemplate()) {
      <ng-container *ngTemplateOutlet="captionTemplate()"></ng-container>
    } @else {
      {{ caption() }}
    }
  </h1>

  @if (descriptionTemplate()) {
    <ng-container *ngTemplateOutlet="descriptionTemplate()"></ng-container>
  } @else if (description()) {
    <p [class]="cx('description')">
      {{ description() }}
    </p>
  }
</header>

<aside [class]="cx('controls')">
  <ng-content />
</aside>
